import {match} from 'ts-pattern';

import {SaneCustomer, SaneCustomerType} from '../types';

export interface SaneCustomerContactIds {
  customerId: string;
  contactId: string | null;
}

/**
 * Resolves the `{customerId, contactId}` pair to persist when a customer is picked
 * from {@link CustomerSelectSearch} (`onCustomerSelect`).
 *
 * A picked contact person (`type === 'contactPerson'`) is persisted as-is. For
 * customer-level selections (a company or a physical person) the customer's primary
 * contact is used when known; otherwise `contactId` stays `null` and the backend
 * resolves the primary contact / founding person itself. The legacy search variant
 * never resolves a primary contact, so it degrades to `null` here without any
 * feature-flag check.
 */
export function getSaneCustomerContactIds(customer: SaneCustomer): SaneCustomerContactIds {
  return match<SaneCustomerType, SaneCustomerContactIds>(customer.type)
    .with('contactPerson', () => ({
      customerId: customer.customerId,
      contactId: customer.id,
    }))
    .with('business', 'physicalPerson', () => ({
      customerId: customer.customerId,
      contactId: customer.primaryContact?.id ?? null,
    }))
    .exhaustive();
}
